/** Drawer mobile (overlay) com a navegação por categorias — equivalente ao
 *  mobileSidebar do V1, com filtro e sinônimos. */
import { useMemo, useState } from 'react';
import { filterCategories } from '../search';

export function MobileDrawer({
  open,
  activeKey,
  onClose,
  onOpen,
}: {
  open: boolean;
  activeKey: string | null;
  onClose: () => void;
  onOpen: (key: string) => void;
}) {
  const [filter, setFilter] = useState('');
  const cats = useMemo(() => filterCategories(filter), [filter]);

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 md:hidden">
      {/* backdrop */}
      <div className="absolute inset-0 bg-black/70 backdrop-blur-sm" onClick={onClose} />
      {/* painel */}
      <div className="absolute left-0 top-0 bottom-0 w-80 max-w-[85%] bg-white border-r border-gray-200 shadow-2xl flex flex-col animate-[slidein_0.2s_ease]">
        <div className="p-4 border-b border-gray-100 flex items-center justify-between">
          <span className="font-bold text-slate-900 flex items-center gap-2">
            <i className="fas fa-list-ul text-indigo-600" /> Tutoriais
          </span>
          <button
            onClick={onClose}
            className="w-9 h-9 rounded-lg bg-gray-100 border border-gray-200 flex items-center justify-center text-slate-500 hover:text-slate-900 transition"
            aria-label="Fechar menu"
          >
            <i className="fas fa-times" />
          </button>
        </div>

        <div className="p-3 border-b border-gray-100">
          <div className="relative">
            <i className="fas fa-filter absolute left-3 top-1/2 -translate-y-1/2 text-slate-400 text-xs" />
            <input
              type="text"
              value={filter}
              onChange={(e) => setFilter(e.target.value)}
              placeholder="Filtrar…"
              className="w-full bg-gray-100 border border-gray-200 rounded-lg pl-9 pr-3 py-2 text-xs text-slate-800 placeholder-slate-400 outline-none focus:bg-white focus:border-indigo-500 transition"
            />
          </div>
        </div>

        <nav className="flex-1 overflow-y-auto custom-scroll py-2">
          {cats.length === 0 ? (
            <div className="px-4 py-8 text-center text-slate-400 text-sm">Nenhum tutorial encontrado.</div>
          ) : (
            cats.map((cat) => (
              <div key={cat.slug} className="mb-1">
                <div className="px-4 pt-3 pb-1 text-[10px] font-bold text-slate-400 uppercase tracking-wider">
                  {cat.title}
                </div>
                {cat.items.map((it) => {
                  const active = it.key === activeKey;
                  return (
                    <button
                      key={it.key}
                      onClick={() => onOpen(it.key)}
                      className={`w-full text-left px-4 py-3 text-sm flex items-center gap-2 transition border-l-2 ${
                        active
                          ? 'bg-indigo-50 text-indigo-700 border-indigo-600 font-bold'
                          : 'text-slate-600 border-transparent hover:bg-gray-50 hover:text-slate-900'
                      }`}
                    >
                      <i className={`${it.icon} w-5 text-center text-xs ${active ? 'text-indigo-600' : 'text-slate-400'}`} />
                      <span className="truncate">{it.label}</span>
                    </button>
                  );
                })}
              </div>
            ))
          )}
        </nav>
      </div>
    </div>
  );
}
